import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { take, isBoolean } from 'lodash';
import ProgressBar from '../progress-bar';
import DateTimeDisplay from '../date-time-display';

import { getAuditLogs } from '../../modules/Setup/SetupActions';

class ChangeLog extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      loading: false,
      logs: [],
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.setState({ loading: true, loaded: false }, () => {
      this.props.dispatch((getAuditLogs(this.props.organization, this.props.type, this.props.subjectId)))
        .then(
          (results) => {
            if (this.mounted) {
              this.setState({ loaded: true, loading: false, logs: results.docs || [] });
            }
          },
          () => {
            if (this.mounted) {
              this.setState({ loaded: true, loading: false, logs: [] });
            }
          }
        );
    });
    
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  
  render() {    
    const { loading, loaded, logs } = this.state;
    if (loading) {
      return (<ProgressBar />);
    }
    if (!logs || logs.length === 0) {
      return null;
    }
    return (
      <div>
        <hr />
        <h6>{this.props.label} Audit Logs:</h6>
        <table className="table table-condensed table-striped">
          <thead>
            <tr>
              <th>Modifier</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
          {take(logs, this.props.limit).map((log) => {
            const oldValue = isBoolean(log.old_value) ? (log.old_value ? 'TRUE' : 'FALSE') : log.old_value;
            const newValue = isBoolean(log.new_value) ? (log.new_value ? 'TRUE' : 'FALSE') : log.new_value;
            return (
              <tr key={log._id}>
                <td>
                  <strong>{log.user !== undefined ? `${log.user.first_name} ${log.user.last_name}` : log.user__id}</strong>
                </td>
                <td><s>{oldValue}</s></td>
                <td><code>{newValue}</code></td>
                <td><em><DateTimeDisplay value={log.created_at} format="shortWithTimeAt" /></em></td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ChangeLog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  subjectId: PropTypes.string.isRequired,
  limit: PropTypes.number,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
};
ChangeLog.defaultProps = {
  limit: 5,
};

export default connect(mapStateToProps)(ChangeLog);
